<template>
  <div class="w-full pb-2 flex flex-col justify-start items-start gap-[15px]">
    <div class="w-full flex justify-start items-start gap-[11px]">
      <button
        v-if="hasPermission('Orders_View')"
        :class="[
          'text-[14px] font-semibold leading-[20px] cursor-pointer focus:outline-none py-[5px]',
          {
            'border-b-2 border-[#2463EB] text-[#2463EB]':
              activeTabProp === 'orders',
            'text-[#96a0b5]': activeTabProp !== 'orders',
          },
        ]"
        @click="switchTab('orders'), refreshOrder()"
      >
        All Orders
      </button>
      <!-- <button
        :class="[
          'text-[14px] font-semibold leading-[20px] cursor-pointer focus:outline-none py-[5px]',
          {
            'border-b-2 border-[#2463EB] text-[#2463EB]':
              activeTabProp === 'cancelled',
            'text-[#96a0b5]': activeTabProp !== 'cancelled',
          },
        ]"
        @click="switchTab('cancelled'), refreshCancel()"
      >
        Cancelled Request
      </button> -->
      <button
        v-if="hasPermission('Inventory_Reconcile_Stock_View')"
        :class="[
          'text-[14px] font-semibold leading-[20px] cursor-pointer focus:outline-none py-[5px]',
          {
            'border-b-2 border-[#2463EB] text-[#2463EB]':
              activeTabProp === 'product',
            'text-[#96a0b5]': activeTabProp !== 'product',
          },
        ]"
        @click="switchTab('product')"
      >
        Product Sales
      </button>
    </div>
    <div
      v-if="activeTabProp === 'orders'"
      class="flex xs:flex-col md:flex-row xs:justify-start md:justify-between w-full xs:items-start xs:gap-4 lg-gap-2 md:items-center"
    >
      <p class="text-[#353535] text-[14px] leading-[20px] font-semibold">
        All Orders
      </p>
      <div
        class="flex gap-1 sm:gap-3 flex-wrap xs:justify-start lg:justify-center xs:items-start lg:items-center"
      >
        <button
          @click="viewFilter"
          class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
        >
          <span class="">
            <img src="/assets/icon/sort.svg" alt="" />
          </span>
          Filter
        </button>
        <button
          @click="newOrder"
          class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none"
        >
          <span class="feather icon-plus text-white"></span> New order
        </button>
      </div>
    </div>
    <div
      v-if="activeTabProp === 'cancelled'"
      class="flex xs:flex-col md:flex-row xs:justify-start md:justify-between w-full xs:items-start xs:gap-4 lg-gap-2 md:items-center"
    >
      <p class="text-[#353535] text-[14px] leading-[20px] font-semibold">
        Cancelled Request
      </p>
      <!-- <button
        class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
      >
        <span class="">
          <img src="/assets/icon/sort.svg" alt="" />
        </span>
        Filters
      </button> -->
    </div>
    <div
      v-if="activeTabProp === 'product'"
      class="flex xs:flex-col md:flex-row xs:justify-start md:justify-between w-full xs:items-start xs:gap-4 lg-gap-2 md:items-center"
    >
      <p class="text-[#353535] text-[14px] leading-[20px] font-semibold">
        Product Sales
      </p>
      <button
        @click="toggleProductFilter"
        class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
      >
        <span class="">
          <img src="/assets/icon/sort.svg" alt="" />
        </span>
        Filters
      </button>
    </div>
    <newOrderModal
      :closeModal="closeModal"
      v-if="isModalVisible"
      :refreshOrder="getUpdatedOrder"
    />
  </div>
</template>

<script>
import newOrderModal from "./newOrderModal.vue";
import { bus } from "../../main";

export default {
  components: {
    newOrderModal,
  },
  props: [
    "hasPermission",
    "activeTabProp",
    "viewFilter",
    "toggleProductFilter",
    "refreshCancel",
    "refreshOrder",
  ],
  data: () => ({
    isBusy: false,
    isModalVisible: false,
  }),
  created() {
    bus.$on("OpenOrderModal", this.OpenOrderModal);
  },
  methods: {
    switchTab(tab) {
      this.$emit("switchTab", tab);
    },
    OpenOrderModal(id) {
      this.isModalVisible = true;
      document.body.style.overflow = "hidden";
    },
    newOrder() {
      this.isModalVisible = true;
      document.body.style.overflow = "hidden";
    },
    closeModal() {
      this.isModalVisible = false;
      document.body.style.overflow = "auto";
    },
    getUpdatedOrder() {
      this.refreshOrder();
    },
  },
};
</script>
